import React from "react";

const Modal = ({
  isOpen,
  title,
  onClose,
  children,
  footer,
  maxWidthClass = "max-w-md",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className={`bg-white w-full ${maxWidthClass} rounded-lg shadow-lg p-6`}>
        {title && (
          <h3 className="text-lg font-semibold text-primary mb-4 text-center">
            {title}
          </h3>
        )}
        <div>{children}</div>
        {footer && (
          <div className="flex justify-center gap-3 mt-6">{footer}</div>
        )}
      </div>
    </div>
  );
};

export default Modal;
